<template>
  <div class="ins-main support-main">
    <div class="groupHeading">
      {{$t('lang_men_serviceAdvantage')}}
    </div>
    <ul class="select-tab">
      <li 
        v-for="(tab,index) in navs"        
        :class="{active:index===nowIndex}"
        :key=index
      >
        <router-link :to="`/support/${tab.rel}`">
          <div>
            <i :class="tab.icon"></i>
            <span>{{ tab.txt }}</span>
          </div>
        </router-link>
      </li>
    </ul>
    <div class="support_inner">
      <section v-show='currentTab==="prot"'>
        <ul>
          <template v-if="isMobile">
            <carousel
              :perPage="1"
              :mouse-drag="false"
              :navigationEnabled="true"
              :navigationNextLabel="`<span class='icon-32'></span>`"
              :navigationPrevLabel="`<span class='icon-32'></span>`"
              :paginationEnabled="true"
              :loop="true">
              <slide>
                <li>
                  <div class="support_content">
                    <div class="switch-mb"><img src="@img/support/support_prot_mb_1.jpg" alt=""></div>
                    <div class="switch-pc"><img src="@img/support/support_prot_1.png" alt=""></div>
                    <div class="support_intro">
                      <div class="support_intro_title">
                        <span>01</span>
                        <span v-html="$t('lang_advantageTheme1_list1_title')"></span>
                      </div>
                      <div class="support_intro_msg">{{$t('lang_advantageTheme1_list1_msg')}}</div>
                    </div>
                  </div>
                </li>
              </slide>
              <slide>
                <li>
                  <div class="support_content">
                    <div class="switch-mb"><img src="@img/support/support_prot_mb_2.jpg" alt=""></div>
                    <div class="support_intro">
                      <div class="support_intro_title">
                        <span>02</span>
                        <span v-html="$t('lang_advantageTheme1_list2_title')"></span>
                      </div>
                      <div class="support_intro_msg">{{$t('lang_advantageTheme1_list2_msg')}}</div>
                    </div>
                    <div class="switch-pc"><img src="@img/support/support_prot_2.png" alt=""></div>
                  </div>
                </li>
              </slide>
              <slide>
                <li>
                  <div class="support_content">
                    <div class="switch-mb"><img src="@img/support/support_prot_mb_3.jpg" alt=""></div>
                    <div class="switch-pc"><img src="@img/support/support_prot_3.png" alt=""></div>
                    <div class="support_intro">
                      <div class="support_intro_title">
                        <span>03</span>
                        <span v-html="$t('lang_advantageTheme1_list3_title')"></span>
                      </div>
                      <div class="support_intro_msg">{{$t('lang_advantageTheme1_list3_msg')}}</div>
                    </div>
                  </div>
                </li>
              </slide>
              <slide>
                <li>
                  <div class="support_content">
                    <div class="switch-mb"><img src="@img/support/support_prot_mb_4.jpg" alt=""></div>
                    <div class="support_intro">
                      <div class="support_intro_title">
                        <span>04</span>
                        <span v-html="$t('lang_advantageTheme1_list4_title')"></span>
                      </div>
                      <div class="support_intro_msg">{{$t('lang_advantageTheme1_list4_msg')}}</div>
                    </div>
                    <div class="switch-pc"><img src="@img/support/support_prot_4.png" alt=""></div>
                  </div>
                </li>
              </slide>
              <slide>
                <li>
                  <div class="support_content">
                    <div class="switch-mb"><img src="@img/support/support_prot_mb_5.jpg" alt=""></div>
                    <div class="switch-pc"><img src="@img/support/support_prot_5.png" alt=""></div>
                    <div class="support_intro">
                      <div class="support_intro_title">
                        <span>05</span>
                        <span v-html="$t('lang_advantageTheme1_list5_title')"></span>
                      </div>
                      <div class="support_intro_msg">{{$t('lang_advantageTheme1_list5_msg')}}</div>
                    </div>
                  </div>
                </li>
              </slide>
            </carousel>
          </template>
          <template v-else>
            <li>
              <div class="support_content">
                <div class="switch-mb"><img src="@img/support/support_prot_mb_1.jpg" alt=""></div>
                <div class="switch-pc"><img src="@img/support/support_prot_1.png" alt=""></div>
                <div class="support_intro">
                  <div class="support_intro_title">
                    <span>01</span>
                    <span v-html="$t('lang_advantageTheme1_list1_title')"></span>
                  </div>
                  <div class="support_intro_msg">{{$t('lang_advantageTheme1_list1_msg')}}</div>
                </div>
              </div>
            </li>
            <li>
              <div class="support_content">
                <div class="switch-mb"><img src="@img/support/support_prot_mb_2.jpg" alt=""></div>
                <div class="support_intro">
                  <div class="support_intro_title">
                    <span>02</span>
                    <span v-html="$t('lang_advantageTheme1_list2_title')"></span>
                  </div>
                  <div class="support_intro_msg">{{$t('lang_advantageTheme1_list2_msg')}}</div>
                </div>
                <div class="switch-pc"><img src="@img/support/support_prot_2.png" alt=""></div>
              </div>
            </li>              
            <li>
              <div class="support_content">
                <div class="switch-mb"><img src="@img/support/support_prot_mb_3.jpg" alt=""></div>
                <div class="switch-pc"><img src="@img/support/support_prot_3.png" alt=""></div>
                <div class="support_intro">
                  <div class="support_intro_title">
                    <span>03</span>
                    <span v-html="$t('lang_advantageTheme1_list3_title')"></span>
                  </div>
                  <div class="support_intro_msg">{{$t('lang_advantageTheme1_list3_msg')}}</div>
                </div>
              </div>
            </li>
            <li>
              <div class="support_content">
                <div class="switch-mb"><img src="@img/support/support_prot_mb_4.jpg" alt=""></div>
                <div class="support_intro">
                  <div class="support_intro_title">
                    <span>04</span>
                    <span v-html="$t('lang_advantageTheme1_list4_title')"></span>
                  </div>
                  <div class="support_intro_msg">{{$t('lang_advantageTheme1_list4_msg')}}</div>
                </div>
                <div class="switch-pc"><img src="@img/support/support_prot_4.png" alt=""></div>
              </div>
            </li>
            <li>
              <div class="support_content">
                <div class="switch-mb"><img src="@img/support/support_prot_mb_5.jpg" alt=""></div>
                <div class="switch-pc"><img src="@img/support/support_prot_5.png" alt=""></div>
                <div class="support_intro">
                  <div class="support_intro_title">
                    <span>05</span>
                    <span v-html="$t('lang_advantageTheme1_list5_title')"></span>
                  </div>
                  <div class="support_intro_msg">{{$t('lang_advantageTheme1_list5_msg')}}</div>
                </div>
              </div>
            </li>
          </template>
        </ul>
      </section>
      <section v-show='currentTab==="equi"'>
        <ul>
          <template v-if="isMobile">
            <carousel
              :perPage="1"
              :mouse-drag="false"
              :navigationEnabled="true"
              :navigationNextLabel="`<span class='icon-32'></span>`"
              :navigationPrevLabel="`<span class='icon-32'></span>`"
              :paginationEnabled="true"
              :loop="true">
              <slide>
                <li>
                  <div class="support_content">
                    <div class="switch-mb"><img src="@img/support/support_equi_mb_1.jpg" alt=""></div>
                    <div class="switch-pc"><img src="@img/support/support_equi_1.png" alt=""></div>
                    <div class="support_intro">
                      <div class="support_intro_title">
                        <span>01</span>
                        <span v-html="$t('lang_advantageTheme2_list1_title')"></span>
                      </div>
                      <div class="support_intro_msg">{{$t('lang_advantageTheme2_list1_msg')}}</div>
                    </div>
                  </div>
                </li>
              </slide>
              <slide>
                <li>
                  <div class="support_content">
                    <div class="switch-mb"><img src="@img/support/support_equi_mb_2.jpg" alt=""></div>
                    <div class="support_intro">
                      <div class="support_intro_title">
                        <span>02</span>
                        <span v-html="$t('lang_advantageTheme2_list2_title')"></span>
                      </div>
                      <div class="support_intro_msg">{{$t('lang_advantageTheme2_list2_msg')}}</div>
                    </div>
                    <div class="switch-pc"><img src="@img/support/support_equi_2.png" alt=""></div>
                  </div>
                </li>
              </slide>
              <slide>
                <li>
                  <div class="support_content">
                    <div class="switch-mb"><img src="@img/support/support_equi_mb_3.jpg" alt=""></div>
                    <div class="switch-pc"><img src="@img/support/support_equi_3.png" alt=""></div>
                    <div class="support_intro">
                      <div class="support_intro_title">
                        <span>03</span>
                        <span v-html="$t('lang_advantageTheme2_list3_title')"></span>
                      </div>
                      <div class="support_intro_msg">{{$t('lang_advantageTheme2_list3_msg')}}</div>
                    </div>
                  </div>
                </li>
              </slide>
              <slide>
                <li>
                  <div class="support_content">
                    <div class="switch-mb"><img src="@img/support/support_equi_mb_4.jpg" alt=""></div>
                    <div class="support_intro">
                      <div class="support_intro_title">
                        <span>04</span>
                        <span v-html="$t('lang_advantageTheme2_list4_title')"></span>
                      </div>
                      <div class="support_intro_msg">{{$t('lang_advantageTheme2_list4_msg')}}</div>
                    </div>
                    <div class="switch-pc"><img src="@img/support/support_equi_4.png" alt=""></div>
                  </div>
                </li>
              </slide>
            </carousel>
          </template>
          <template v-else>
            <li>
              <div class="support_content">
                <div class="switch-mb"><img src="@img/support/support_equi_mb_1.jpg" alt=""></div>
                <div class="switch-pc"><img src="@img/support/support_equi_1.png" alt=""></div>
                <div class="support_intro">
                  <div class="support_intro_title">
                    <span>01</span>
                    <span v-html="$t('lang_advantageTheme2_list1_title')"></span>
                  </div>
                  <div class="support_intro_msg">{{$t('lang_advantageTheme2_list1_msg')}}</div>
                </div>
              </div>
            </li>
            <li>
              <div class="support_content">
                <div class="switch-mb"><img src="@img/support/support_equi_mb_2.jpg" alt=""></div>
                <div class="support_intro">
                  <div class="support_intro_title">
                    <span>02</span>
                    <span v-html="$t('lang_advantageTheme2_list2_title')"></span>
                  </div>
                  <div class="support_intro_msg">{{$t('lang_advantageTheme2_list2_msg')}}</div>
                </div>
                <div class="switch-pc"><img src="@img/support/support_equi_2.png" alt=""></div>
              </div>
            </li>
            <li>
              <div class="support_content">
                <div class="switch-mb"><img src="@img/support/support_equi_mb_3.jpg" alt=""></div>
                <div class="switch-pc"><img src="@img/support/support_equi_3.png" alt=""></div>
                <div class="support_intro">
                  <div class="support_intro_title">
                    <span>03</span>
                    <span v-html="$t('lang_advantageTheme2_list3_title')"></span>
                  </div>
                  <div class="support_intro_msg">{{$t('lang_advantageTheme2_list3_msg')}}</div>
                </div>
              </div>
            </li>
            <li>
              <div class="support_content">
                <div class="switch-mb"><img src="@img/support/support_equi_mb_4.jpg" alt=""></div>
                <div class="support_intro">
                  <div class="support_intro_title">
                    <span>04</span>
                    <span v-html="$t('lang_advantageTheme2_list4_title')"></span>
                  </div>
                  <div class="support_intro_msg">{{$t('lang_advantageTheme2_list4_msg')}}</div>
                </div>
                <div class="switch-pc"><img src="@img/support/support_equi_4.png" alt=""></div>
              </div>
            </li>
          </template>
        </ul>
      </section>
      <section  v-show='currentTab==="moni"'>
        <ul>
          <template v-if="isMobile">
            <carousel
              :perPage="1"
              :mouse-drag="false"
              :navigationEnabled="true"
              :navigationNextLabel="`<span class='icon-32'></span>`"
              :navigationPrevLabel="`<span class='icon-32'></span>`"
              :paginationEnabled="true"
              :loop="true">
              <slide>
                <li>
                  <div class="support_content">
                    <div class="switch-mb"><img src="@img/support/support_moni_mb_1.jpg" alt=""></div>
                    <div class="switch-pc"><img src="@img/support/support_moni_1.png" alt=""></div>
                    <div class="support_intro">
                      <div class="support_intro_title">
                        <span>01</span>
                        <span v-html="$t('lang_advantageTheme3_list1_title')"></span>
                      </div>
                      <div class="support_intro_msg">{{$t('lang_advantageTheme3_list1_msg')}}</div>
                    </div>
                  </div>
                </li>
              </slide>
              <slide>
                <li>
                  <div class="support_content">
                    <div class="switch-mb"><img src="@img/support/support_moni_mb_2.jpg" alt=""></div>
                    <div class="support_intro">
                      <div class="support_intro_title">
                        <span>02</span>
                        <span v-html="$t('lang_advantageTheme3_list2_title')"></span>
                      </div>
                      <div class="support_intro_msg">{{$t('lang_advantageTheme3_list2_msg')}}</div>
                    </div>
                    <div class="switch-pc"><img src="@img/support/support_moni_2.png" alt=""></div>
                  </div>
                </li>
              </slide>
              <slide>
                <li>
                  <div class="support_content">
                    <div class="switch-mb"><img src="@img/support/support_moni_mb_3.jpg" alt=""></div>
                    <div class="switch-pc"><img src="@img/support/support_moni_3.png" alt=""></div>
                    <div class="support_intro">
                      <div class="support_intro_title">
                        <span>03</span>
                        <span v-html="$t('lang_advantageTheme3_list3_title')"></span>
                      </div>
                      <div class="support_intro_msg">{{$t('lang_advantageTheme3_list3_msg')}}</div>
                    </div>
                  </div>
                </li>
              </slide>
            </carousel>
          </template>
          <template v-else>                
            <li>
              <div class="support_content">
                <div class="switch-mb"><img src="@img/support/support_moni_mb_1.jpg" alt=""></div>
                <div class="switch-pc"><img src="@img/support/support_moni_1.png" alt=""></div>
                <div class="support_intro">
                  <div class="support_intro_title">
                    <span>01</span>
                    <span v-html="$t('lang_advantageTheme3_list1_title')"></span>
                  </div>
                  <div class="support_intro_msg">{{$t('lang_advantageTheme3_list1_msg')}}</div>
                </div>
              </div>
            </li>                
            <li>
              <div class="support_content">
                <div class="switch-mb"><img src="@img/support/support_moni_mb_2.jpg" alt=""></div>
                <div class="support_intro">
                  <div class="support_intro_title">
                    <span>02</span>
                    <span v-html="$t('lang_advantageTheme3_list2_title')"></span>
                  </div>
                  <div class="support_intro_msg">{{$t('lang_advantageTheme3_list2_msg')}}</div>
                </div>
                <div class="switch-pc"><img src="@img/support/support_moni_2.png" alt=""></div>
              </div>
            </li>                
            <li>
              <div class="support_content">
                <div class="switch-mb"><img src="@img/support/support_moni_mb_3.jpg" alt=""></div>
                <div class="switch-pc"><img src="@img/support/support_moni_3.png" alt=""></div>
                <div class="support_intro">
                  <div class="support_intro_title">
                    <span>03</span>
                    <span v-html="$t('lang_advantageTheme3_list3_title')"></span>
                  </div>
                  <div class="support_intro_msg">{{$t('lang_advantageTheme3_list3_msg')}}</div>
                </div>
              </div>
            </li>            
          </template>
        </ul>
      </section>
    </div>
  </div>
</template>
<script>
import $ from 'jquery'
import { Carousel, Slide } from 'vue-carousel';

export default {
  name: 'Support',
  components: {
    Carousel,
    Slide
  },
  data(){
    return{
      currentTab: 'prot',
      nowIndex: 0,
      isMobile: false,
      deviceModel: 'pc'
    }
  },
  watch:{
    '$route' (to) {
      this.currentTab = to.params.name
      this.toTab(this.currentTab)
    }
  },
  computed: {
    navs(){
      return[
        {
          rel: 'prot',
          icon: 'icon-prot',
          txt: this.$t('lang_men_superProtection')
        },
        {
          rel: 'equi',
          icon: 'icon-equi',
          txt: this.$t('lang_men_topEquipment')
        },
        {
          rel: 'moni',
          icon: 'icon-moni',
          txt: this.$t('lang_men_monitor')
        }
      ]
    }
  },
  methods: {
    toTab(item){
      const index =item=== 'prot' ? 0 : item === 'equi' ? 1 : 2
      this.nowIndex = index
    },
    getDevice: function(){
      window.addEventListener('resize',this.windowRes)
      this.windowRes()
    },
    windowRes: function(){
      const $this = this
      if($this.deviceModel === 'mb' && $(window).width() > 996) {
        $this.isMobile = false
        $this.deviceModel = 'pc'
      }else if ($this.deviceModel === 'pc' && $(window).width() <= 996){
        $this.isMobile = true
        $this.deviceModel = 'mb'
      }  
    }
  },
  mounted() {
    this.currentTab = this.$route.params.name
    this.getDevice()
    this.toTab(this.currentTab)
    this.$store.dispatch('setLoadshow',false)
  },
  beforeDestroy(){
    this.$store.dispatch('setLoadshow',true)
    window.removeEventListener('resize',this.windowRes)
  }
}
</script>
<style lang="sass">
  @import '@css/support.sass'
</style>
